export default __webpack_public_path__ + "43da5636b91d4e8b7ecf3667920cc6ac.png";